export const I18N_PREFIX = 'pages.reviewNotification'

export enum ReviewNotificationsIntervalType {
  immediate = 'immediate',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum ReviewNotificationsFilterEvaluation {
  equal = 'equal', // values are equal
  not = 'not', // values are not equal
  lt = 'lt', // left value is less than right
  lte = 'lte', // left value is less than or equal to right
  gt = 'gt', // left value is greater than right
  gte = 'gte', // left value is greater than or equal to right
  contains = 'contains', // an array or string has a value inside
  notContains = 'notContains', // an array or string does not have a value inside
  fuzzyContains = 'fuzzyContains', // an array or string has a value inside
}

export enum ReviewNotificationsFilterSource {
  label = 'label',
  location = 'location',
  folder = 'folder',
  rating = 'rating',
  recommended = 'recommended',
  publisher = 'publisher',
  content = 'content',
  hasDraft = 'hasDraft',
}

export type FilterOptions = Array<{
  label: string
  value: ReviewNotificationsFilterSource
}>

type FilterKeyType<T extends ReviewNotificationsFilterSource> =
  T extends ReviewNotificationsFilterSource.location
    ? 'stores'
    : T extends ReviewNotificationsFilterSource.folder
      ? 'folders'
      : T extends ReviewNotificationsFilterSource.publisher
        ? 'publishers'
        : T extends ReviewNotificationsFilterSource.content
          ? 'contents'
          : T extends ReviewNotificationsFilterSource.label
            ? 'labels'
            : T

type FilterContentType<T extends ReviewNotificationsFilterSource> =
  T extends ReviewNotificationsFilterSource.location
    ? string[]
    : T extends ReviewNotificationsFilterSource.folder
      ? string[]
      : T extends ReviewNotificationsFilterSource.rating
        ? number
        : T extends ReviewNotificationsFilterSource.recommended
          ? boolean
          : T extends ReviewNotificationsFilterSource.publisher
            ? string[]
            : T extends ReviewNotificationsFilterSource.label
              ? string[]
              : T extends ReviewNotificationsFilterSource.content
                ? string[]
                : T extends ReviewNotificationsFilterSource.hasDraft
                  ? boolean
                  : never

type ContentFilterShape<T extends ReviewNotificationsFilterSource> = {
  [K in FilterKeyType<T>]: FilterContentType<T>
}

export type ReviewNotificationsFilterProps<T extends ReviewNotificationsFilterSource> = T extends
  | ReviewNotificationsFilterSource.location
  | ReviewNotificationsFilterSource.folder
  | ReviewNotificationsFilterSource.publisher
  | ReviewNotificationsFilterSource.label
  | ReviewNotificationsFilterSource.content
  | ReviewNotificationsFilterSource.hasDraft
  | ReviewNotificationsFilterSource.rating
  | ReviewNotificationsFilterSource.recommended
  ? {
      source: T
      evaluation: ReviewNotificationsFilterEvaluation
    } & ContentFilterShape<T>
  : never

export type ReviewNotificationsFilterPropsUnion =
  | ReviewNotificationsFilterProps<ReviewNotificationsFilterSource.location>
  | ReviewNotificationsFilterProps<ReviewNotificationsFilterSource.folder>
  | ReviewNotificationsFilterProps<ReviewNotificationsFilterSource.rating>
  | ReviewNotificationsFilterProps<ReviewNotificationsFilterSource.recommended>
  | ReviewNotificationsFilterProps<ReviewNotificationsFilterSource.publisher>
  | ReviewNotificationsFilterProps<ReviewNotificationsFilterSource.label>
  | ReviewNotificationsFilterProps<ReviewNotificationsFilterSource.content>
  | ReviewNotificationsFilterProps<ReviewNotificationsFilterSource.hasDraft>
